class _ViewSet {
    constructor(backendRoute) {
        this.backendRoute = backendRoute;
    }
    _slashRoute(url) {
        let slashUrl = url;
        if (slashUrl.slice(-1) !== '/') {
            slashUrl += '/'
        }
        return slashUrl;
    }
    slashBackendRoute(parentUrl) {
        let backendRoute = this._slashRoute(this.backendRoute);
        if (parentUrl) {
            backendRoute = this._slashRoute(parentUrl) + backendRoute;
        }
        return backendRoute;
    }
    list(parentUrl = null) {
        return this.slashBackendRoute(parentUrl);
    }
    detail(id, parentUrl = null) {
        return this.slashBackendRoute(parentUrl) + id + '/';
    }
}

export default {
    accounts: {
        profile: new _ViewSet('accounts/users/profile')
    },
    organizations: {
        default: new _ViewSet('organizations'),
        groups: new _ViewSet('organizations/groups'),
        activities: new _ViewSet('organizations/activities'),
    },
    municipalities: {
        default: new _ViewSet('municipalities')
    },
    requests: {
        default: new _ViewSet('requests'),
        status: new _ViewSet('statuses'),
        activities: new _ViewSet('requests/activities'),
        contracts: new _ViewSet('contracts/available'),
        address: new _ViewSet('address'),
        xlsx: new _ViewSet('requests/xlsx'),
        customers: new _ViewSet('requests/customers'),
        contractors: new _ViewSet('requests/contractors'),
        archive: new _ViewSet('requests/archive'),  // для перемещения в архив сразу множества записей
        extract: new _ViewSet('requests/extract'),  // для перемещения из архива сразу множества записей
        deleteIrreversibly: new _ViewSet('requests/delete-irreversibly'),  // для безвозвратного удаления сразу множества записей
    },
    raids: {
        default: new _ViewSet('raids'),
        statuses: new _ViewSet('raids/statuses'),
        attachments: new _ViewSet('attachments'),
    },
    addresses: {
        default: new _ViewSet('addresses'),
        osm: new _ViewSet('addresses/osm'),
        search: new _ViewSet('addresses/search'),
        reverse: new _ViewSet('addresses/reverse')
    },
    species: {
        default: new _ViewSet('species')
    },
    breeds: {
        default: new _ViewSet('breeds')
    },
    contracts: {
        default: new _ViewSet('contracts'),
        types: new _ViewSet('contracts/types'),
        nullableTypes: new _ViewSet('contracts/nullable-types'),
        receivers: new _ViewSet('contracts/receivers')
    },
    animals: {
        default: new _ViewSet('animals'),
        genders: new _ViewSet('animals/genders'),
        events: new _ViewSet('events'),  // TODO: нигде не используется
        pdf: new _ViewSet('pdf'),
        eventKinds: new _ViewSet('events/kinds'),
        eventAttachments: new _ViewSet('attachments'),
        gallery: new _ViewSet('gallery'),
        ownerTypes: new _ViewSet('owner/types'),
        hairTypes: new _ViewSet('hair/types'),
        earCrop: new _ViewSet('ear/types'),
        tailCrop: new _ViewSet('tail/types'),
        colorGroups: new _ViewSet('animals/color-groups'),
        aggressionLevels: new _ViewSet('animals/aggression'),
        xlsx: new _ViewSet('animals/xlsx'),
        nextRegNumber: new _ViewSet('animals/next-reg-number'),
        currentEvents: new _ViewSet('current-events'), // для списка мероприятий на странице животных
        shelters: new _ViewSet('animals/shelters'), // для обхода ограничений по правам на отображение организаций для не-ИОГВ (используется в фильтре по приютам в списке животных)
        archive: new _ViewSet('animals/archive'),  // для перемещения в архив сразу множества записей
        extract: new _ViewSet('animals/extract'),  // для перемещения из архива сразу множества записей
        deleteIrreversibly: new _ViewSet('animals/delete-irreversibly'),  // для безвозвратного удаления сразу множества записей
        review: new _ViewSet('review')
    },
    events: {
        default: new _ViewSet('events'),
        attachments: new _ViewSet('attachments'),
        xlsx: new _ViewSet('events/xlsx'),
        batchDelete: new _ViewSet('events/delete'),
        contractors: new _ViewSet('events/contractors'), // для обхода ограничений по правам на отображение организаций для не-ИОГВ (используется в фильтре по исполнителям в списке мероприятий)
        customers: new _ViewSet('events/customers'),
        address: new _ViewSet('address'),
        ownerTypes: new _ViewSet('events/owner-types'),
        euthanasiaReasons: new _ViewSet('events/euthanasia-reasons'),
    },
    attachments: {
        default: new _ViewSet('attachments')
    },
    surveyStages: {
        default: new _ViewSet('survey-stages'),
        reactions: new _ViewSet('reactions'),
        conclusions: new _ViewSet('survey-stages/conclusions')
    },
    euthanasiaReasons: {
        default: new _ViewSet('euthanasia-reasons'),
    },
    statistics: {
        default: new _ViewSet('statistics/reports'),
        download: new _ViewSet('download')
    },
    news: {
        default: new _ViewSet('news'),
        status: new _ViewSet('news/statuses'),
        attachments: new _ViewSet('attachments'),
        authors: new _ViewSet('news/authors')
    },
    questionGroups: {
        default: new _ViewSet('question-groups')
    },
    questions: {
        default: new _ViewSet('questions'),
        attachments: new _ViewSet('attachments'),
    }
}